module.exports = __webpack_public_path__ + "img/menu.a502d7d2.svg";